import { useState } from 'react';
import { DesktopWrap, DesktopBWrap } from './Desktop.styles';
import { QrcodeBaileys, QrcodeGeorge, LogoContentMagazine } from '@assets/svgs';
import Link from 'next/link';

type DesktopProps = {
  children: React.ReactNode;
  showGMdesktop?: boolean;
  showBaileyDesktop?: boolean;
  showFashionDesktop?: boolean;
};

const ContentItems = () => {
  return (
    <>
      <span>Please</span>
      <h2>SCAN THE QR CODE AND USE YOU PHONE</h2>
      <span className="bottomText">to continue</span>
    </>
  );
};

const Desktop = ({
  children,
  showGMdesktop,
  showBaileyDesktop,
  showFashionDesktop
}: DesktopProps) => {
  return (
    <>
      {showGMdesktop && (
        <DesktopWrap>
          <div>
            <QrcodeGeorge />
            <ContentItems />
          </div>
        </DesktopWrap>
      )}
      {showBaileyDesktop && (
        <DesktopBWrap>
          <div>
            <QrcodeBaileys />
            <ContentItems />
            <Link href="/Thestory">
              <LogoContentMagazine animation="logoContent" />
            </Link>
          </div>
        </DesktopBWrap>
      )}
      {showFashionDesktop && <></>}
      {children}
    </>
  );
};

export default Desktop;
